import React from 'react';
import { Flex, Tooltip, Box, Icon, Text } from '@fullstory/components';
import { Display } from '@fullstory/proto/fs/services/webber/frontend/display';
import { TimeRangeComparison } from '@fullstory/proto/fs/services/search-settings/visualizationsettings';
import { TimeRange } from '@fullstory/proto/fs/api/segment';
import { TooltipRow } from '../TooltipRow';
import { useSingleNumberComparison } from '../../hooks';
import { FormattedMessage } from 'react-intl';

interface SingleNumberComparisonProps {
  value: number;
  pastValue: number;
  timeRange: TimeRange | null;
  pastRange?: TimeRangeComparison | null;
  inverse?: boolean;
  displayFormat?: Display;
}

export const SingleNumberComparison: React.FC<SingleNumberComparisonProps> = ({
  value,
  pastValue,
  timeRange,
  pastRange,
  inverse = false,
  displayFormat,
}) => {
  const { previousRange, currentRange, comparisonText, comparisonValue, valueText, pastValueText } =
    useSingleNumberComparison({
      value,
      pastValue,
      timeRange,
      pastRange,
      displayFormat,
    });

  const textColor = inverse ? 'default-inverse' : 'default';
  const isSameValue = value === pastValue;

  return (
    <Tooltip
      data-component="SingleNumberComparison"
      tooltipContent={
        comparisonText &&
        previousRange && (
          <>
            <TooltipRow rangeText={currentRange} value={valueText} />
            <TooltipRow rangeText={previousRange} value={pastValueText} />
          </>
        )
      }
      disabled={!comparisonText}
    >
      <Flex testId="single-number-commparison">
        {isSameValue && (
          <Text appearance="bodySmallBold" color={textColor}>
            <FormattedMessage defaultMessage="No Change" id="oYnwe1" />
          </Text>
        )}
        {!isSameValue && (
          <>
            <Box marginRight={4}>
              <Icon
                size={16}
                color={textColor}
                name={value > pastValue ? 'caret-up' : 'caret-down'}
              />
            </Box>
            <Text appearance="bodySmallBold" color={textColor}>
              {isFinite(comparisonValue) ? (
                comparisonText
              ) : (
                <FormattedMessage defaultMessage="N/A" id="zQE4f2" description="Not applicable" />
              )}
            </Text>
          </>
        )}
      </Flex>
    </Tooltip>
  );
};
